(function(){
 var key='rsd_cookie_consent',banner=document.getElementById('rsd-cookie');
 function load(){
  if(window.__rsdTrackingLoaded)return;window.__rsdTrackingLoaded=true;
  var g=document.createElement('script');g.async=true;g.src='https://www.googletagmanager.com/gtag/js?id=G-NB2278GC93';document.head.appendChild(g);
  window.dataLayer=window.dataLayer||[];window.gtag=function(){dataLayer.push(arguments)};gtag('js',new Date());gtag('config','G-NB2278GC93',{anonymize_ip:true});
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
  fbq('init','4258709124394016');fbq('track','PageView');
 }
 var state=localStorage.getItem(key);
 if(state==='accepted')load();else if(!state&&banner)banner.hidden=false;
 document.addEventListener('click',function(e){
  if(e.target.matches('[data-cookie-accept]')){localStorage.setItem(key,'accepted');banner.hidden=true;load()}
  if(e.target.matches('[data-cookie-reject]')){localStorage.setItem(key,'rejected');banner.hidden=true}
 });
})();